export * from './buy-win.page'
